import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import ImageGallery from '../components/gallery/ImageGallery';

const SearchResultsHeader = styled.div`
  padding: 1rem 2rem;
  background-color: ${props => props.theme.colors.background.secondary};
  border-bottom: 1px solid ${props => props.theme.colors.border.primary};
`;

const SearchQuery = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  color: ${props => props.theme.colors.text.primary};
`;

const SearchPage: React.FC = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const query = searchParams.get('q') || '';
  const [hasResults, setHasResults] = useState(true);

  const handleResultsStatus = (hasAnyResults: boolean) => {
    setHasResults(hasAnyResults);
  };

  return (
    <div>
      {(hasResults || !query) && (
        <SearchResultsHeader>
          <SearchQuery>
            {query ? `Resultados para: "${query}"` : 'Todas las imágenes'}
          </SearchQuery>
        </SearchResultsHeader>
      )}
      <ImageGallery searchQuery={query} onResultsStatus={handleResultsStatus} />
    </div>
  );
};

export default SearchPage;